import React, {useEffect, useRef} from 'react';
import ImageBasic from "../Image/ImageBasic";
import IMG from "../../../constants/image";
import {clsx} from "clsx";
import appStore from "../../../store/appStore";
import {isEmpty} from "lodash";

const Popup = ({isOpen, onClose, children, bgClass, buttonCloseClass, isHideButtonClose}) => {
    const {animate, setAnimate} = appStore()
    const popupRef = useRef();
    // Remove animation after it completes
    useEffect(() => {
        if (!isEmpty(animate)) {
            const timer = setTimeout(() => {
                setAnimate(false)
            }, 300); // Match this to your animation duration
            return () => clearTimeout(timer);
        }
    }, [animate]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                onClose();
            }
        };

        const handleScroll = (event) => {
            if (isOpen) {
                event.preventDefault();
            }
        };

        if (isOpen) {
            document.body.classList.add('overflow-hidden');
            document.addEventListener('mousedown', handleClickOutside);
            document.addEventListener('scroll', handleScroll, {passive: false});
        } else {
            document.body.classList.remove('overflow-hidden');
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('scroll', handleScroll);
        }

        return () => {
            document.body.classList.remove('overflow-hidden');
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('scroll', handleScroll);
        };
    }, [isOpen, onClose]);
    if (!isOpen) return null;
    return (
        <div
            className={clsx("fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 animate-fadeIn")}>
            <div ref={popupRef}
                 className={clsx(bgClass ? bgClass : 'bg-white',
                     animate?.direction === 'left' && 'animate-scaleInLeft',
                     animate?.direction === 'right' && 'animate-scaleInRight',
                     animate?.direction === 'center' && 'animate-fadeIn',
                     "relative p-4 md:p-6 rounded-[20px] shadow-lg")}>
                {!isHideButtonClose && <button onClick={onClose} className={
                    clsx(buttonCloseClass ? buttonCloseClass : 'top-2 right-2', "absolute text-gray-500 hover:text-gray-700")}>
                    <ImageBasic className='w-5' src={IMG.icon.close}/>
                </button>}
                {children}
            </div>
        </div>
    );
};

export default Popup;